// Vendorly brand mark — Option B "The Signal V"
// Single source of truth: change here → updates everywhere in the app.
export default function VendorlyLogo({ size = 32, className = "" }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Vendorly">
      <rect width="100" height="100" rx="22" fill="#4A5D4E" />
      <path d="M25 28 L50 72 L75 28" stroke="#FDFBF7" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <g transform="translate(66 22)">
        <rect width="14" height="14" rx="2" fill="#D97757" />
        <rect x="3" y="3" width="8" height="8" rx="1" fill="#FDFBF7" />
        <rect x="5.5" y="5.5" width="3" height="3" fill="#D97757" />
      </g>
      <path d="M48 74 L50 84 L54 74 Z" fill="#FDFBF7" />
    </svg>
  );
}

export function VendorlyWordmark({ size = 26, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <VendorlyLogo size={size} />
      <span className="font-heading font-bold tracking-tight" style={{ fontSize: size * 0.72 }}>Vendorly</span>
    </div>
  );
}
